import React from 'react';
import DashboardContainer from '../components/layout/DashboardContainer';
import { Mail, CalendarClock, MessageCircle, ChevronDown } from 'lucide-react';

export default function SupportPage() {
  return (
    <DashboardContainer>
      <div className="support-page-wrapper">
        <h1 className="support-title">Help & Support</h1>
        <p className="support-subtitle">Questions about Blastmate? We're here to help.</p>

        {/* Contact cards */}
        <div className="support-contacts-grid">
          <a className="support-contact-card" href="mailto:support@blastmate.in">
            <div className="support-contact-icon" style={{ background: '#eef2ff', color: '#6366f1' }}>
              <Mail size={20} />
            </div>
            <div>
              <strong>Email</strong>
              <span className="muted-sm">support@blastmate.in</span>
            </div>
          </a>
          <a className="support-contact-card" href="https://cal.com/blastmate/support" target="_blank" rel="noreferrer">
            <div className="support-contact-icon" style={{ background: '#ecfdf5', color: '#22c55e' }}>
              <CalendarClock size={20} />
            </div>
            <div>
              <strong>Book a Demo</strong>
              <span className="muted-sm">30-minute walkthrough</span>
            </div>
          </a>
        </div>

        {/* FAQ */}
        <div className="support-faq-card">
          <h3>Frequently Asked Questions</h3>
          <details className="support-faq-item">
            <summary>
              <span>How do I connect my WhatsApp Business account?</span>
              <ChevronDown size={16} className="faq-chevron" />
            </summary>
            <div className="faq-answer">
              Go to <strong>Settings › WhatsApp Integration</strong> and click "Connect with Facebook" to follow the step-by-step guide.
            </div>
          </details>
          <details className="support-faq-item">
            <summary>
              <span>Can I send bulk campaigns?</span>
              <ChevronDown size={16} className="faq-chevron" />
            </summary>
            <div className="faq-answer">
              Yes — once your templates are approved by Meta, you can schedule and send campaigns from the <strong>Campaigns</strong> page.
            </div>
          </details>
          <details className="support-faq-item">
            <summary>
              <span>Where do I find billing information?</span>
              <ChevronDown size={16} className="faq-chevron" />
            </summary>
            <div className="faq-answer">
              Open <strong>Billing</strong> from the sidebar to view your usage summary and estimated costs.
            </div>
          </details>
        </div>
      </div>
    </DashboardContainer>
  );
}